"use client";

import Typography from "@/shared/components/common/Typography";
import data from "@/public/data/hotel/results.json";
import tourData from "@/public/data/tour/results.json";
import { CaretLeft } from "@phosphor-icons/react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "./BreadcrumbItem";
import PhosphorIcon from "../PhosphorIcon";

interface BreadCrumbProps {
  module?: "flight" | "tour" | "hotel";
  page: "result" | "detail";
  city: string;
  hotel?: {
    code: string;
    persian: string;
  };
  from?: string;
}

export default function BreadCrumb({ module, page, city, hotel, from }: BreadCrumbProps) {
  const {
    body: {
      breadcrumb: { b1, b2 },
    },
  } = data;

  const {
    body: {
      breadcrumb: { b1: tourB1, b2: tourB2 },
    },
  } = tourData;

  return (
    <Breadcrumb className="px-2">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink
            className="text-muted-foreground hover:text-foreground dark:text-foreground hover:dark:text-foreground/80"
            href={`${module === "tour" ? tourB1.href : b1.href}/`}
          >
            <Typography variant="body1" className="font-medium max-md:!text-sm">
              {module === "tour" ? tourB1.label : b1.label}
            </Typography>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <PhosphorIcon
            name="CaretLeft"
            size={14}
            weight="light"
            className="text-muted-foreground dark:text-foreground/70"
          />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <BreadcrumbLink
            href={hotel?.code ? `${b2.href}/${hotel?.code}/` : undefined}
            className={`text-muted-foreground hover:text-foreground dark:text-foreground hover:dark:text-foreground/80 ${
              page === "result" && "hover:text-muted-foreground"
            }`}
          >
            <Typography variant="body1" className="font-medium max-md:!text-sm">
              {`${module === "tour" ? tourB2.label : b2.label} ${city} ${(module === "tour" && from) ? "از" : ""} ${(module === "tour" && from) ? from : ""}`}
            </Typography>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {page === "detail" && (
          <>
            <BreadcrumbSeparator>
              <PhosphorIcon
                name="CaretLeft"
                size={14}
                weight="light"
                className="text-muted-foreground dark:text-foreground/70"
              />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink className="text-muted-foreground hover:text-foreground dark:text-foreground">
                <Typography
                  variant="body1"
                  className="font-medium max-md:!text-sm"
                >
                  {hotel?.persian}
                </Typography>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
